/* eslint no-unused-vars: "off" */
/* eslint import/no-useless-path-segments: "off" */
import React, { useContext, useState } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useIntersectionObserver } from 'usehooks-ts';
import Card from '../../components/_common/card/Card';
import { DigitalGloveBoxCardWrapper } from './DigitalGloveBoxCard.styles';
import DocDownloadList from '../../components/_common/doc-download-list/DocDownloadList';
import GloveBoxIcon from '../../assets/GloveBoxIcon';
import { AnalyticEvents } from '../../constants';

const DigitalGloveBoxCard = ({ feedData, positionValue, userState }: any) => {
  const { trackEvent } = useContext(AnalyticsContext) as any;
  const [cardPosition] = useState(positionValue || 0);
  const { hostEnvironment } = userState;

  const {
    id: cardId,
    title,
    content: { gloveboxDocuments },
  } = feedData;

  const captionText = 'Access your important car related documents.';
  const documentList = gloveboxDocuments;

  const captureImpression = () => {
    setTimeout(() => {
      trackEvent(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
      });
      datadogRum.addAction(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
      });
    }, 1000);
  };
  const { ref } = useIntersectionObserver({
    freezeOnceVisible: true,
    threshold: 0.5,
    onChange: (isIntersecting, entry) => {
      if (isIntersecting && captureImpression) captureImpression();
    },
  });

  // Redirect to post sale updates page
  const clickEventHandler = (eventName: string, document?: string) => {
    trackEvent(eventName, {
      cardId,
      cardPosition,
      document,
    });
    datadogRum.addAction(eventName, {
      cardId,
      cardPosition,
      document,
    });
  };

  const header = {
    title,
  };

  return (
    <DigitalGloveBoxCardWrapper ref={ref}>
      <Card dataQa="digital-glovebox" header={header} headerIcon={<GloveBoxIcon />}>
        <DocDownloadList
          heading={captionText}
          documentList={documentList}
          clickEventHandler={clickEventHandler}
          env={hostEnvironment}
        />
      </Card>
    </DigitalGloveBoxCardWrapper>
  );
};

export default DigitalGloveBoxCard;
